var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('accordion',[_c('panel',{attrs:{"title":"DIMENCIONAMENTO"}},[_vm._v(" DIMENCIONAMENTO ... ")]),_vm._v(" "),_c('panel',{attrs:{"title":"HIGIENE OCUPACIONAL"}},[_vm._v(" HIGIENE OCUPACIONAL ... ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9314f690","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sst/seguranca/components/mapRisco/map-components/mapeamento.vue
// module id = null
// module chunks = 